/* eslint-disable @typescript-eslint/no-explicit-any */
import type { History } from '@remix-run/router';

import { createContext } from '@change/core/react/context';

import type { ModalConfig } from './shared/types';

export const {
	Context: ModalsContext,
	Provider: ModalsContextProvider,
	useContext: useModalsContext,
} = createContext<{
	history?: History;
	modal: ModalConfig<any, any, any> | undefined;
	setModal: (
		setModal: (modal: ModalConfig<any, any, any> | undefined) => ModalConfig<any, any, any> | undefined,
	) => void;
}>(
	// these will be overridden in ModalsContainer
	{
		history: undefined,
		modal: undefined,
		setModal: () => {
			/* do nothing as this is the default value to be overridden */
		},
	},
	{
		name: 'ModalsContext',
	},
);
